import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import InputError from 'components/form/input-error'

import styles from 'components/form/form-style'

const FormInput = props => {
  const classes = styles(props.theme)

  const labelClassNames = classNames(
    classes.label,
    {
      [classes.dynamicLabel]: props.dynamicLabel,
      [classes.dynamicLabelOnTop]: props.dynamicLabel && !!(props.meta.active || props.input.value || props.placeholder),
      [classes.dynamicLabelActive]: props.dynamicLabel && props.meta.active,
    }
  )

  return (
    <div className={classNames(classes.block, props.className)}>
      {props.label && <label className={labelClassNames}>{props.label}</label>}
      {props.children}
      {props.hideErrorMessage !== true &&
        <InputError meta={props.meta} direction={props.errorDirection} />
      }
    </div>
  )
}

FormInput.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  theme: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  errorDirection: PropTypes.string,
  hideErrorMessage: PropTypes.bool,
}

FormInput.defaultProps = {
  errorDirection: 'right',
}

export default withTheme(FormInput)
